const STATUS = {
  ERROR: 'error',
  INITIAL: 'initial',
  LOSE: 'lose',
  SPIN: 'spin',
  START: 'start',
  WIN: 'win',
};

export { STATUS };
